export enum UserPermission {
  Access = `AbpIdentity.Users`,
  Create = `AbpIdentity.Users.Create`,
  Update = `AbpIdentity.Users.Update`,
  Delete = `AbpIdentity.Users.Delete`,
}

export enum RolePermission {
  Access = `AbpIdentity.Roles`,
  Create = `AbpIdentity.Roles.Create`,
  Update = `AbpIdentity.Roles.Update`,
  Delete = `AbpIdentity.Roles.Delete`,
  ManagePermissions = `AbpIdentity.Roles.ManagePermissions`,
}

export enum ProductPermission {
  Default = `Business.Product`,
  Create = `Business.Product.Create`,
  Update = `Business.Product.Update`,
  Delete = `Business.Product.Delete`,
  Material = `Business.Product.Material`,
  DimensionWeight = `Business.Product.DimensionWeight`,
  Process = `Business.Product.Process`,
  Approve = `Business.Product.Approve`,
  ViewFile = `Business.Product.Image`,
  UploadFile = "Business.Product.Image.Create",
  DownloadFile = "Business.Product.Image.Download",
  DeleteFile = "Business.Product.Image.Delete",
  PrintTestNote = "Business.Product.PrintTestNote",
}

export enum CustomerPermission {
  Default = `Business.Customer`,
  Create = `Business.Customer.Create`,
  Update = `Business.Customer.Update`,
  Delete = `Business.Customer.Delete`,
}

export enum EmployeePermission {
  Default = `Business.Employees`,
  Create = `Business.Employees.Create`,
  Update = `Business.Employees.Update`,
  Delete = `Business.Employees.Delete`,
  UpdateInformation = `Business.Employees.UpdateInformation`,
  UpdateContractInsurance = `Business.Employees.UpdateContractInsurance`,
}

export enum DeliveryNotesPermission {
  Default = `Business.DeliveryNote`,
  Create = `Business.DeliveryNote.Create`,
  Update = `Business.DeliveryNote.Update`,
  Delete = `Business.DeliveryNote.Delete`,
  PrintDeliveryNote = "Business.DeliveryNote.PrintDeliveryNote",
  ExportExcel = "Business.DeliveryNote.ExportExcel",
}

export enum PurchaseOrdersPermission {
  Default = `Business.PurchaseOrder`,
  Create = `Business.PurchaseOrder.Create`,
  Update = `Business.PurchaseOrder.Update`,
  Delete = `Business.PurchaseOrder.Delete`,
  ManageItem = `Business.PurchaseOrder.Update.ManageItem`,
  ViewAndUpdatePrice = `Business.PurchaseOrder.ViewAndUpdatePrice`,
  ExportExcel = `Business.PurchaseOrder.ExportExcel`,
}

export enum QuotationsPermission {
  Default = `Business.Quotation`,
  Create = `Business.Quotation.Create`,
  Update = `Business.Quotation.Update`,
  Delete = `Business.Quotation.Delete`,
  Print = "Business.Quotation.Print",
}

export enum WorkOrdersPermission {
  Default = `Business.WorkOrders`,
  Create = `Business.WorkOrders.Create`,
  Update = `Business.WorkOrders.Update`,
  Delete = `Business.WorkOrders.Delete`,
  Product = `Business.WorkOrders.Product`,
  Process = `Business.WorkOrders.Process`,
  Print = `Business.WorkOrders.Print`,
  Foil = `Business.WorkOrders.Foil`,
  Shape = `Business.WorkOrders.Shape`,
  Cut = `Business.WorkOrders.Cut`,
  Paste = `Business.WorkOrders.Paste`,
  Package = `Business.WorkOrders.Package`,
  OtherHandle = `Business.WorkOrders.OtherHandle`,
}

export enum WorkOrdersPoProcessPermission {
  Default = `Business.WorkOrders.Progress`,
  PaperOutput = `Business.WorkOrders.Progress.PaperOutput`,
  Print = `Business.WorkOrders.Progress.Print`,
  Matte = `Business.WorkOrders.Progress.Matte`,
  Acceptance = `Business.WorkOrders.Progress.Acceptance`,
  Foil = `Business.WorkOrders.Progress.Foil`,
  Shape = `Business.WorkOrders.Progress.Shape`,
  Paste = `Business.WorkOrders.Progress.Paste`,
  Cut = `Business.WorkOrders.Progress.Cut`,
  Package = `Business.WorkOrders.Progress.Package`,
}

export enum ProductInventoryPermission {
  Default = `Business.ProductWarehouse`,
  Import = `Business.ProductWarehouse.Import`,
  ImportCreate = "Business.ProductWarehouse.Import.Create",
  ImportUpdate = "Business.ProductWarehouse.Import.Update",
  ImportDelete = "Business.ProductWarehouse.Import.Delete",
  Export = `Business.ProductWarehouse.Export`,
  ExportCreate = "Business.ProductWarehouse.Export.Create",
  ExportUpdate = "Business.ProductWarehouse.Export.Update",
  ExportDelete = "Business.ProductWarehouse.Export.Delete",
}

export enum MaterialPermission {
  Default = `Business.Material`,
  Create = `Business.Material.Create`,
  Update = `Business.Material.Update`,
  Delete = `Business.Material.Delete`,
}

export enum MaterialInventoriesPermission {
  Default = `Business.MaterialInventory`,
  Receipt = `Business.MaterialInventory.Receipt`,
  ReceiptCreate = "Business.MaterialInventory.Receipt.Create",
  ReceiptUpdate = "Business.MaterialInventory.Receipt.Update",
  ReceiptDelete = "Business.MaterialInventory.Receipt.Delete",
  Issue = `Business.MaterialInventory.Issue`,
  IssueCreate = "Business.MaterialInventory.Issue.Create",
  IssueUpdate = "Business.MaterialInventory.Issue.Update",
  IssueDelete = "Business.MaterialInventory.Issue.Delete",
}

export enum PaperMaterialsPermission {
  Default = `Business.PaperMaterial`,
  Create = `Business.PaperMaterial.Create`,
  Update = `Business.PaperMaterial.Update`,
  Delete = `Business.PaperMaterial.Delete`,
}

export enum PaperMaterialInventoriesPermission {
  Default = `Business.PaperMaterialInventory`,
  Receipt = `Business.PaperMaterialInventory.Import`,
  ReceiptCreate = "Business.PaperMaterialInventory.Import.Create",
  ReceiptUpdate = "Business.PaperMaterialInventory.Import.Update",
  ReceiptDelete = "Business.PaperMaterialInventory.Import.Delete",
  Issue = `Business.PaperMaterialInventory.Export`,
  IssueCreate = "Business.PaperMaterialInventory.Export.Create",
  IssueUpdate = "Business.PaperMaterialInventory.Export.Update",
  IssueDelete = "Business.PaperMaterialInventory.Export.Delete",
  ExportExcelByRollNumber = "Business.PaperMaterialInventory.ExportExcelByRollNumber",
}

export enum PackingNotesPermission {
  Default = `Business.PackingNotes`,
  Create = `Business.PackingNotes.Create`,
  Update = `Business.PackingNotes.Update`,
  Delete = `Business.PackingNotes.Delete`,
  PrintPackingNote = "Business.PackingNotes.PrintPackingNote",
}

export enum StellaInspectionsPermission {
  Default = `Business.InspectionNoteStellas`,
  Create = `Business.InspectionNoteStellas.Create`,
  Update = `Business.InspectionNoteStellas.Update`,
  Delete = `Business.InspectionNoteStellas.Delete`,
  Print = "Business.InspectionNoteStellas.PrintInspectionNote",
}

export enum DualLangInspectionsPermission {
  Default = `Business.InspectionNoteSNs`,
  Create = `Business.InspectionNoteSNs.Create`,
  Update = `Business.InspectionNoteSNs.Update`,
  Delete = `Business.InspectionNoteSNs.Delete`,
  Print = "Business.InspectionNoteSNs.PrintInspectionNote",
}
